import * as React from 'react'
import { ActionButton } from 'uiComponents/buttons'
import { DisabledItemHoverInfotip } from 'uiComponents/infotip'
import { SAVE } from 'capacity/copy'

interface SaveAreaProps {
    label: string
    disabledReason: string | null
    confirming: boolean
    confirmText: string
    busy: boolean
    onSave: () => void
    onConfirm: () => void
    onKeepEditing: () => void
}

export function SaveArea({
    label,
    disabledReason,
    confirming,
    confirmText,
    busy,
    onSave,
    onConfirm,
    onKeepEditing,
}: SaveAreaProps) {
    return (
        <div className="capacity-save-area">
            {confirming ? (
                <>
                    <p className="capacity-confirm-text">{confirmText}</p>
                    <ActionButton type="button" size="large" secondary onClick={onKeepEditing} disabled={busy}>
                        {SAVE.keepEditing}
                    </ActionButton>
                    <ActionButton type="button" size="large" onClick={onConfirm} disabled={busy}>
                        {busy ? SAVE.saving : SAVE.confirm}
                    </ActionButton>
                </>
            ) : disabledReason ? (
                <DisabledItemHoverInfotip active infotipText={disabledReason} width="22em" bottom toTheLeft>
                    <ActionButton type="button" size="large" disabled>
                        {label}
                    </ActionButton>
                </DisabledItemHoverInfotip>
            ) : (
                <ActionButton type="button" size="large" onClick={onSave}>
                    {label}
                </ActionButton>
            )}
        </div>
    )
}
